export const MAX_PROJECTS_IN_GRID = 5;
export const MAX_PROJECTS_MOBILE_GRID = 4;
